import crossfilter from "crossfilter2";
let denuncia_meses_bar = [],
  denuncia_meses_linea = [],
  denuncia_tipo_medio = [],
  denuncia_tipo_fuente = [],
  denuncia_mes = [],
  denuncia_periodo = [],
  denuncia_tabla = [],
  denuncia_region = [],
  denuncia_sector = [],
  denuncia_total = 0,
  ndx = [];
let dataOefa = (mdx, regions, periodo_anio) => {
  let mdx2 = [];
  ndx = [];
  denuncia_total = 0;
  denuncia_meses_bar = [];
  denuncia_meses_linea = [];
  denuncia_tipo_medio = [];
  denuncia_tipo_fuente = [];
  denuncia_mes = [];
  denuncia_periodo = [];
  denuncia_tabla = [];
  denuncia_region = [];
  denuncia_sector = [];
  let list_region = [];
  let list_region_code = [];
  if (regions == null) {
    regions = [];
  }
  if (regions.length > 0) {
    regions.map(function(item) {
      list_region.push(item.label);
      list_region_code.push(item.value);
    });
    if (list_region_code.includes("00")) {
      mdx.map(function(item) {
        if (item.anio === parseInt(periodo_anio)) {
          mdx2.push(item);
        }
      });
    } else {
      mdx.map(function(item) {
        if (
          list_region.includes(item.departamento) &&
          item.anio === parseInt(periodo_anio)
        ) {
          mdx2.push(item);
        }
      });
    }
  }
  ndx = crossfilter(mdx2);
  denuncia_total = mdx2.length;
  const agua_group = ndx.dimension(d => d.es_agua > 0).group();
  const aire_group = ndx.dimension(d => d.es_aire > 0).group();
  const suelo_group = ndx.dimension(d => d.es_suelo > 0).group();
  if (suelo_group.all().length > 0) {
    denuncia_tipo_medio = [
      {
        name: "Agua",
        y: agua_group
          .reduceSum(function(d) {
            return d.es_agua;
          })
          .top(1)[0].value,
        color: "#3E7DCD"
      },
      {
        name: "Aire",
        y: aire_group
          .reduceSum(function(d) {
            return d.es_aire;
          })
          .top(1)[0].value,
        color: "#ABD7F1"
      },
      {
        name: "Suelo",
        y: suelo_group
          .reduceSum(function(d) {
            return d.es_suelo;
          })
          .top(1)[0].value,
        color: "#78BE78"
      }
    ];
  }

  const sonora_group = ndx.dimension(d => d.es_sonora > 0).group();
  const visual_group = ndx.dimension(d => d.es_visual > 0).group();
  const gas_group = ndx.dimension(d => d.es_gas > 0).group();
  const particulado_group = ndx.dimension(d => d.es_particulado > 0).group();
  const radiacion_group = ndx.dimension(d => d.es_radiacion > 0).group();
  const vert_liquido_group = ndx.dimension(d => d.es_vert_liquido > 0).group();
  const vert_solido_group = ndx.dimension(d => d.es_vert_solido > 0).group();

  if (sonora_group.all().length > 0) {
    denuncia_tipo_fuente = [
      {
        name: "Sonora",
        y: sonora_group
          .reduceSum(function(d) {
            return d.es_sonora;
          })
          .top(1)[0].value,
        color: "#5CB4E5"
      },
      {
        name: "Visual",
        y: visual_group
          .reduceSum(function(d) {
            return d.es_visual;
          })
          .top(1)[0].value,
        color: "#C67BAB"
      },
      {
        name: "Gases",
        y: gas_group
          .reduceSum(function(d) {
            return d.es_gas;
          })
          .top(1)[0].value,
        color: "#7BC69E"
      },
      {
        name: "Particulado",
        y: particulado_group
          .reduceSum(function(d) {
            return d.es_particulado;
          })
          .top(1)[0].value,
        color: "#8B7BC6"
      },
      {
        name: "Radiación",
        y: radiacion_group
          .reduceSum(function(d) {
            return d.es_radiacion;
          })
          .top(1)[0].value,
        color: "#658BDD"
      },
      {
        name: "Vert. Líquido",
        y: vert_liquido_group
          .reduceSum(function(d) {
            return d.es_vert_liquido;
          })
          .top(1)[0].value,
        color: "#DDB765"
      },
      {
        name: "Vert. Sólido",
        y: vert_solido_group
          .reduceSum(function(d) {
            return d.es_vert_solido;
          })
          .top(1)[0].value,
        color: "#A7BBC4"
      }
    ];
  }
  /**
   * Denuncias por meses
   */
  const periodo_group = ndx.dimension(d => d.anio).group();
  const periodo_category = [];
  const periodo_datos = [];
  if (periodo_group.all().length > 0) {
    periodo_group.all().map(function(item, j) {
      periodo_category.push(item.key);
      periodo_datos.push(item.value);
    });
    denuncia_periodo.category = periodo_category;
    denuncia_periodo.datos = periodo_datos;
  }

  /**
   * Denuncias por regiones
   */
  let _child = [];
  let category = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre"
  ];

  if (list_region_code.includes("00")) {
    let datos = [];
    let mes_dim = ndx.dimension(function(d) {
      return d.mes;
    });
    let mes_group = mes_dim.group();
    mes_group.all().map(function(item) {
      datos.push(parseInt(item.value));
    });
    _child.push({ name: "NACIONAL", data: datos });
  } else {
    regions.map(function(items) {
      let myitems = [];
      mdx2.map(function(content) {
        if (content.departamento === items.label) {
          myitems.push(content);
        }
      });
      let _ndx = crossfilter(myitems);
      let datos = [];
      let mes_dim = _ndx.dimension(function(d) {
        return d.mes;
      });
      let mes_group = mes_dim.group();
      mes_group.all().map(function(item) {
        datos.push(parseInt(item.value));
      });
      _child.push({ name: items.label, data: datos });
    });
  }

  denuncia_mes.category = category;
  denuncia_mes.datos = _child;
  if (ndx.all().length > 0) {
    let count=1;
    ndx.all().map(function(item) {
      let child = [];
      child.codigo = item.codigo;
      child.departamento = item.departamento;
      child.provincia = item.provincia;
      child.distrito = item.distrito;
      child.estado = item.estado;
      child.sector = item.sector;
      child.fecha_registro = item.fecha_registro;
      child.modo_presentado = item.modo_presentado;
      child.tipo_actividad = item.tipo_actividad;
      child.item=count;
      denuncia_tabla.push(child);
      count++;
    });
  }
  let _category = [];
  let _items = [];
  let _data = [];
  if (ndx.all().length > 0) {
    let _dimension_region = ndx.dimension(d => d.departamento).group();
    _dimension_region.top(Number.POSITIVE_INFINITY).map(function(item) {
      _category.push(item.key);
      _items.push(item.value);
    });
  }
  _data = [{ name: "Departamento", data: _items }];
  denuncia_region.datos = _data;
  denuncia_region.category = _category;
  /**
   * Sector Data
   */
  _category = [];
  _items = [];
  if (ndx.all().length > 0) {
    let _dimension_region = ndx.dimension(d => d.sector).group();
    _dimension_region.top(Number.POSITIVE_INFINITY).map(function(item) {
      _category.push(item.key);
      _items.push(item.value);
    });
  }
  _data = [{ name: "Sector", data: _items }];
  denuncia_sector.datos = _data;
  denuncia_sector.category = _category;
};

export default dataOefa;
export {
  denuncia_meses_bar,
  denuncia_meses_linea,
  denuncia_tipo_medio,
  denuncia_tipo_fuente,
  denuncia_periodo,
  denuncia_mes,
  denuncia_tabla,
  denuncia_total,
  denuncia_region,
  denuncia_sector
};
